import { graphql } from '@/generated/gql';

export const INTAKE_DEMAND = graphql(/* GraphQL */ `
  query IntakeDemand($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        demandId
        demandSequenceNumber
      }
    }
  }
`);
